import { render, staticRenderFns } from "./LandingPageList.vue?vue&type=template&id=7da8123a&scoped=true&"
import script from "./LandingPageList.vue?vue&type=script&lang=js&"
export * from "./LandingPageList.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageList.vue?vue&type=style&index=0&id=7da8123a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da8123a",
  null
  
)

export default component.exports